import { createGlobalStyle } from 'styled-components';

const normalize = `
  /*! modern-normalize | MIT License | https://github.com/sindresorhus/modern-normalize */html{box-sizing:border-box}*,::after,::before{box-sizing:inherit}:root{-moz-tab-size:4;tab-size:4}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}body{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'}hr{height:0}abbr[title]{text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,pre,samp{font-family:SFMono-Regular,Consolas,'Liberation Mono',Menlo,Courier,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{padding:0}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}
`;

const GlobalStyles = createGlobalStyle`
  ${normalize};

  html {
    scroll-behavior: smooth;
    scroll-padding-top: 80px; /* Account for fixed navbar */
  }

  /* Enhanced smooth scrolling with custom easing */
  html {
    scroll-behavior: smooth;
  }

  /* Smooth scroll snap for better section navigation */
  body {
    scroll-snap-type: y proximity;
  }

  section {
    scroll-snap-align: start;
    scroll-snap-stop: always;
  }

  /* Enhanced focus styles for better accessibility during navigation */
  *:focus {
    outline: 2px solid ${props => props.theme.color.primary};
    outline-offset: 2px;
    transition: outline 0.2s ease;
  }

  /* Smooth transitions for all interactive elements */
  a, button, input, textarea, select {
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }

  /* Custom scrollbar for webkit browsers */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  body {
    font-family: ${props => props.theme.font.secondary};
  }

  h1, h2, h3, p {
    margin: 0;
    font-weight: normal;
  }

  h1, h2 {
    font-family: ${props => props.theme.font.primary};
  }

  h1 {
    ${props => props.theme.font_size.xlarge};
  }

  h2 {
    ${props => props.theme.font_size.larger};
  }

  h3 {
    ${props => props.theme.font_size.large};
  }

  p {
    ${props => props.theme.font_size.regular};
    color: ${props => props.theme.color.black.regular};
  }

  @media (max-width: ${props => props.theme.screen.sm}) {
    h1 {
      ${props => props.theme.font_size.larger};
    }

    h2 {
      ${props => props.theme.font_size.large};
    }

    h3 {
      ${props => props.theme.font_size.regular};
    }

    p {
      ${props => props.theme.font_size.small};
    }
  }

  button {
    border: none;
    background: none;
    outline: none;
    padding: 0;
    cursor: pointer;
  }

  a {
    cursor: pointer;
  }

  .LinksPage {
    padding: 100px 0;
    min-height: 85vh;
  }

  .userPhoto {
    width: 300px;
    height: 300px;
    display: block;
    margin: 35px auto 20px;
    -webkit-box-shadow: 0px 6px 0px 0px rgba(222, 218, 162, 1);
    -moz-box-shadow: 0px 6px 0px 0px rgba(222, 218, 162, 1);
    box-shadow: 0px 6px 0px 0px rgba(222, 218, 162, 1);
    transition: all 0.15s;
  }
  
  .userPhoto:hover {
    box-shadow: 0px 8px rgba(222, 218, 162, 1);
    transform: translateY(-2px);
  }
  
  .userPhoto:active {
    box-shadow: 0px 0px black;
    transform: translateY(6px);
  }
  
  #userName {
    color: white;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.25;
    display: block;
    font-family: var(--font);
    width: 100%;
    text-align: center;
    text-decoration: none;
  }
  
  #links {
    max-width: 675px;
    width: auto;
    display: block;
    margin: 27px auto;
  }

  /* Video container styles moved to styled-components */
  
  @media only screen and (max-width: 700px) {
    #links {
      margin-left: 3%;
      margin-right: 3%;
    }
    .night_mode {
      margin-right: 40%;
    }
  }
  
  .link {
    display: block;
    background-color: #01A79B;
    color: #fff;
    font-family: var(--font);
    text-align: center;
    margin-bottom: 20px;
    padding: 17px;
    text-decoration: none;
    font-size: 1rem;
    font-weight: bold;
    transition: all 0.15s;
    box-shadow: 0px 6px #007569;
  }
  
  .link:hover {
    /* background: #019489; */
    box-shadow: 0px 8px #007569;
    transform: translateY(-2px);
  }
  
  .link:active {
    transform: translateY(6px);
    box-shadow: 0px 0px #007569;
  }
  
  #proker {
    max-width: 300px;
    width: auto;
    display: grid;
    margin: 27px auto;
  }
  
  .footer {
    text-align: center;
    font-size: 1.3rem;
  }
  
  .footer a {
    text-decoration: none;
  }
  
  .media {
    background: #DD5A79;
    width: 38px;
    height: 38px;
    text-align: center;
    color: white;
    margin-bottom: 40px;
    box-shadow: 0px 6px #9E4355;
    transition: all 0.15s;
  }
  
  .media:hover {
    box-shadow: 0px 8px #9E4355;
    transform: translateY(-2px);
  }
  
  .media:active {
    transform: translateY(6px);
    box-shadow: 0px 0px #9E4355;
  }
`;

export default GlobalStyles;
